import React__default from 'react';
import classNames from 'classnames';
import Styles from './NewQuickFilterPill.module.scss.js';

const NewQuickFilterPill = ({ content, isSelected = false, handleClick, id, disabled = false }) => {
    return (React__default.createElement("div", { className: classNames(Styles.quickFilterPill, isSelected && Styles.isSelected, disabled && Styles.disabled), onClick: () => {
            if (disabled)
                return;
            handleClick(id);
        }, id: `${id}` }, content));
};

export { NewQuickFilterPill as default };
//# sourceMappingURL=NewQuickFilterPill.js.map
